import { createContext, useContext, useState } from "react";

import axios from "axios";

const StockSnapshotContext = createContext();

export const StockSnapshotProvider = ({ children }) => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [stockDetail, setStockDetail] = useState(null);
  const [stockDetailLoading, setStockDetailLoading] = useState(false);
  const [stockDetailError, setStockDetailError] = useState(null);
  const [fundamentals, setFundamentals] = useState(null);
  const [fundamentalsLoading, setFundamentalsLoading] = useState(false);
  const [fundamentalsError, setFundamentalsError] = useState(null);

  const getStockDetailSnapshot = async (symbol, securityId, options = {}) => {
    if (!symbol) return null;
    const { silent = false } = options;

    if (!silent) {
      setStockDetailLoading(true);
      setStockDetailError(null);
    }

    try {
      // setStockDetailLoading(true);
      // setStockDetailError(null);

      const res = await axios.get(
        `${BASE_URL}/api/stock-detail-snapshot/${symbol}`,
        {
          params: {
            market: "india",
            securityId,
          },
        },
      );

      setStockDetail(res.data.data);

      return res.data.data;
    } catch (error) {
      if (!silent) setStockDetailError(error.message);
      console.error(
        "Stock Detail Snapshot Error:",
        error.response?.data || error.message,
      );

      // setStockDetailError(
      //   error.response?.data?.message ||
      //     "Failed to fetch stock detail snapshot",
      // );

      return null;
    } finally {
      if (!silent) setStockDetailLoading(false);
      // setStockDetailLoading(false);
    }
  };

  const getStockFundamentals = async (symbol) => {
    if (!symbol) return null;
    try {
      setFundamentalsLoading(true);
      setFundamentalsError(null);
      const res = await axios.get(
        `${BASE_URL}/api/stock/fundamentals/${symbol}`,
        {
          params: {
            market: "india",
          },
        },
      );
      setFundamentals(res.data.data);
      return res.data.data;
    } catch (err) {
      setFundamentalsError(err);
      console.log("Error from yahoo fundamentals", err?.message);
    } finally {
      setFundamentalsLoading(false);
    }
  };

  const resetStockDetail = () => {
    setStockDetail(null);
    setStockDetailError(null);
  };
  const resetStockFundamental = () => {
    setFundamentals(null);
    setFundamentalsError(null);
  };

  return (
    <StockSnapshotContext.Provider
      value={{
        stockDetail,
        stockDetailLoading,
        stockDetailError,
        getStockDetailSnapshot,
        resetStockDetail,
        getStockFundamentals,
        fundamentals,
        fundamentalsError,
        fundamentalsLoading,
      }}
    >
      {children}
    </StockSnapshotContext.Provider>
  );
};

export const useStockSnapshot = () => useContext(StockSnapshotContext);
